import { isPresent } from '@ember/utils';
import Component from '@glimmer/component';

import type { EmptyObject } from 'shared/types';

/**
 * Removes any flash messages that the backend rendered on the page.
 */
export default class BackendAlertRemoverComponent extends Component {
  constructor(owner: unknown, args: EmptyObject) {
    super(owner, args);
    // this clears out messages from Rails-env.
    const success = document.querySelector('.o--alert--success');
    const danger = document.querySelector('.o--alert--danger');
    const allAlertElements = document.querySelectorAll<HTMLElement>('.o--alert');

    const fadeOut = (element: HTMLElement): void => {
      element.style.transition = '.5s all';
      element.style.opacity = '0';
      setTimeout(() => {
        element.remove();
      }, 500);
    };

    const scheduleFadeOut = (): void => {
      setTimeout(() => {
        [success, danger].filter((i): i is HTMLElement => isPresent(i)).forEach((elem: HTMLElement) => fadeOut(elem));
      }, 2000);
    };

    // Give backend alerts their full visible timeout after the first route loads.
    const loadingIndicator = document.querySelector('.ember-load-indicator');
    if (loadingIndicator) {
      const observer = new MutationObserver(() => {
        if (!loadingIndicator.isConnected) {
          observer.disconnect();
          scheduleFadeOut();
        }
      });
      observer.observe(document.body, { childList: true });
    } else {
      scheduleFadeOut();
    }

    Array.from(allAlertElements).forEach((alert) => {
      alert.addEventListener('click', () => fadeOut(alert));
    });
  }
}
